// Central data for the ViralCrew App Studio section (/apps/*).
// Same legal entity as the agency (Jasko Hodzic / ViralCrew).

export const STUDIO = {
  owner: "Jasko Hodzic",
  brand: "ViralCrew Studio",
  address: ["Friedenstraße 2", "42699 Solingen", "Deutschland"],
  email: "info@viralcrew.de",
  phone: "+49 1522 3701174",
  vat: "DE 368328094",
};

// Each app + its privacy-relevant flags (drives the auto-generated legal text).
export const APPS = [
  {
    slug: "inhale",
    name: "Inhale",
    category: "Breathwork & Entspannung",
    accent: "#00F2FE",
    icon: "Wind",
    iconImage: "/studio-assets/inhale/icon.webp",
    tagline: "Atme dich in Sekunden ruhig.",
    description:
      "Geführte Atemübungen und Entspannungs-Sessions für mehr Ruhe, Fokus und besseren Schlaf. Komplett offline, ohne Account.",
    features: [
      "Geführte Atem-Techniken (Box Breathing, 4-7-8 u. a.)",
      "Lokale Erinnerungen für deine tägliche Session",
      "Alles offline – keine Anmeldung nötig",
    ],
    flags: { local: true, reminders: true },
  },
  {
    slug: "emberly",
    name: "Emberly",
    category: "Habit-Tracker",
    accent: "#FF6B35",
    icon: "Flame",
    iconImage: "/studio-assets/emberly/icon.webp",
    tagline: "Gewohnheiten, die wirklich bleiben.",
    description:
      "Baue Schritt für Schritt gute Gewohnheiten auf und halte deine Streaks am Leben – mit einem klaren, motivierenden Tracker.",
    features: [
      "Tägliche Gewohnheiten & Streaks",
      "Lokale Erinnerungen, damit du dranbleibst",
      "Deine Daten bleiben auf deinem Gerät",
    ],
    flags: { local: true, reminders: true },
  },
  {
    slug: "fitmaxx",
    name: "FitMaxx",
    category: "HIIT & Fitness",
    accent: "#FF0050",
    icon: "Dumbbell",
    iconImage: "/studio-assets/fitmaxx/icon.webp",
    tagline: "Kurze, intensive Workouts – mit KI-Coach.",
    description:
      "Effektive HIIT-Workouts für zuhause und unterwegs, mit optionalem KI-Coach und optionaler Apple-Health-Anbindung.",
    features: [
      "HIIT-Workouts mit Timer",
      "Optionaler KI-Coach (standardmäßig komplett auf dem Gerät)",
      "Optional: abgeschlossene Workouts in Apple Health schreiben",
      "Lokale Erinnerungen für dein Training",
    ],
    flags: { local: true, reminders: true, healthkit: true, openai: true },
  },
  {
    slug: "neonrush",
    name: "NeonRush",
    category: "Arcade-Spiel",
    accent: "#9D4CDD",
    icon: "Gamepad2",
    iconImage: "/studio-assets/neonrush/icon.webp",
    tagline: "Rasanter Neon-Arcade-Rush.",
    description:
      "Ein schnelles, süchtig machendes Arcade-Spiel im Neon-Look – mit Game-Center-Bestenlisten für den Wettkampf.",
    features: [
      "Schnelles Arcade-Gameplay",
      "Game-Center-Bestenlisten",
      "Ansonsten nur lokale Daten",
    ],
    flags: { local: true, gamecenter: true },
  },
  {
    slug: "colorpour",
    name: "ColorPour",
    category: "Puzzle-Spiel",
    accent: "#00E676",
    icon: "Palette",
    iconImage: "/studio-assets/colorpour/icon.webp",
    tagline: "Entspanntes Farb-Sortier-Puzzle.",
    description:
      "Sortiere Farben in immer kniffligeren Leveln – entspannt, elegant und mit Game-Center-Bestenlisten.",
    features: [
      "Hunderte Farb-Sortier-Level",
      "Game-Center-Bestenlisten",
      "Alle Fortschritte lokal auf dem Gerät",
    ],
    flags: { local: true, gamecenter: true },
  },
  {
    slug: "boltsort",
    name: "BoltSort",
    category: "Nut & Screw Puzzle",
    accent: "#F5A623",
    icon: "Wrench",
    iconImage: "/studio-assets/boltsort/icon.webp",
    tagline: "Abschrauben. Sortieren. Entspannen. Keine Werbung, niemals.",
    description:
      "BoltSort ist das ruhige, befriedigende Schrauben-Puzzle: Bewege bunte Muttern zwischen Schrauben, bis auf jeder Schraube nur noch eine Farbe steckt. 1.000 Level und ein tägliches Daily Puzzle – komplett gratis, komplett offline, komplett ohne Werbung.",
    features: [
      "1.000 entspannende Level – alle gratis, nie eine Paywall",
      "Jeden Tag ein neues Daily Puzzle – weltweit identisch, mit Streak",
      "Keine Werbung. Nicht jetzt, niemals.",
      "Komplett offline, ohne Konto",
      "Game-Center-Bestenliste, schöne Themes, sanfte Sounds & Haptik",
      "Optional: BoltSort Pro (Monat/Jahr mit 7 Tagen gratis / Lifetime) für unbegrenzte Undos & Hints und alle Themes",
    ],
    flags: { local: true, reminders: true, gamecenter: true },
    supportEmail: "bena@viralcrew.de",
    privacyIntro:
      "BoltSort erhebt keine Daten („Keine Daten erfasst“ / Data Not Collected im App-Store-Label). Keine Werbung, und alle 1.000 Level sowie das Daily Puzzle sind gratis.",
    pricing: { monthly: "4,99 € / Monat", yearly: "24,99 € / Jahr", lifetime: "39,99 € einmalig", trialDays: 7, proName: "BoltSort Pro" },
    faq: [
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe in der App auf der Pro-Seite auf „Käufe wiederherstellen“ und stelle sicher, dass du mit derselben Apple-ID angemeldet bist." },
      { q: "Wie kündige ich das Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → BoltSort Pro → Kündigen. Mindestens 24 h vor Ablauf; die Kündigung wirkt zum Ende der Laufzeit. Den 7-Tage-Trial (Jahresabo) kannst du dort jederzeit vor Ablauf beenden." },
      { q: "Kostet BoltSort etwas?", a: "Nein. Alle 1.000 Level und das Daily Puzzle sind gratis und werbefrei. Pro ist ein optionales Komfort-Upgrade." },
      { q: "Mein Fortschritt ist weg.", a: "Der Fortschritt liegt nur lokal auf dem Gerät; beim Löschen der App wird er entfernt. Ein Geräte-Backup kann ihn wiederherstellen." },
      { q: "Daily Puzzle / Bestenliste zeigt nichts.", a: "Für die Bestenliste bei Game Center anmelden (iOS-Einstellungen → Game Center). Das Spiel selbst läuft komplett offline." },
    ],
  },
  {
    slug: "rotaledger",
    name: "RotaLedger",
    category: "Arbeitszeit & Lohn · Finanzen / Produktivität",
    accent: "#B8F34A",
    icon: "CalendarClock",
    iconImage: "/studio-assets/rotaledger/icon.webp",
    tagline: "Deine Stunden. Dein Bruttolohn. Klar.",
    description:
      "RotaLedger verbindet Schichtkalender, Arbeitszeiterfassung und Bruttolohn-Schätzung in einer privaten, ruhigen App. Trage Schichten ein oder stemple dich ein und aus – und sieh schon vor dem Zahltag deine geschätzten Bruttoeinnahmen.",
    features: [
      "Schichten manuell eintragen oder ein- und ausstempeln",
      "Unbezahlte Pausen und Nachtschichten korrekt berücksichtigen",
      "Laufende Stunden- und Bruttolohn-Schätzung pro Abrechnungszeitraum",
      "Eigene Überstunden-, Nacht-, Wochenend- und markierte Feiertagsregeln",
      "Mehrere Jobs, Währungen und Abrechnungspläne",
      "Wiederkehrende Schichtmuster und Autofill",
      "Erweiterte Reports sowie PDF- und CSV-Export",
    ],
    flags: { local: true, reminders: true, exports: true },
    supportEmail: "info@viralcrew.de",
    privacyIntro:
      "RotaLedger erhebt keine Daten („Keine Daten erfasst“ / Data Not Collected). Jobs, Schichten, Regeln und Einstellungen bleiben ausschließlich lokal auf deinem Gerät – kein Konto, kein Backend, keine Analyse, keine Werbung.",
    disclaimer:
      "RotaLedger liefert unverbindliche Schätzungen des Bruttolohns und ersetzt keine Lohnabrechnung, Steuer- oder Rechtsberatung. Maßgeblich ist stets die Abrechnung deines Arbeitgebers.",
    pricing: {
      proName: "RotaLedger Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Ein Job",
        "Wiederverwendbare Schichtvorlagen",
        "Manuelle Schichten & Ein-/Ausstempeln",
        "Kernkalender & aktueller Abrechnungszeitraum",
        "Lokaler JSON-Export",
        "Keine Werbung",
      ],
      proIncludes: [
        "Mehrere Jobs",
        "Eigene Überstundenregeln",
        "Nacht-, Wochenend- & selbst markierte Feiertagszuschläge",
        "Wiederkehrende Schichtmuster & Autofill",
        "Erweiterte Historie & detaillierte Reports",
        "PDF- & CSV-Export",
      ],
    },
    faq: [
      { q: "Werden meine Daten übertragen?", a: "Nein. Alle Jobs, Schichten, Regeln und Einstellungen bleiben lokal auf deinem Gerät. Es gibt kein Konto und kein Backend von uns." },
      { q: "Sind die angezeigten Löhne verbindlich?", a: "Nein. RotaLedger liefert eine unverbindliche Bruttolohn-Schätzung. Maßgeblich ist immer die Lohnabrechnung deines Arbeitgebers." },
      { q: "Ist RotaLedger kostenlos?", a: "Ja, die Kernfunktionen (ein Job, manuelle Schichten, Ein-/Ausstempeln, Kernkalender, JSON-Export) sind gratis und werbefrei. RotaLedger Pro ist ein optionales Upgrade." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe in der App auf „Käufe wiederherstellen“ und stelle sicher, dass du mit derselben Apple-ID angemeldet bist." },
      { q: "Wie kündige ich Pro?", a: "iOS-Einstellungen → [dein Name] → Abonnements → RotaLedger Pro → Kündigen. Mindestens 24 h vor Ablauf; die Kündigung wirkt zum Ende der Laufzeit." },
      { q: "Wie exportiere ich meine Daten?", a: "Über das Teilen-Menü von Apple: JSON ist gratis, PDF- und CSV-Export sind Teil von Pro. Der Export wird nur durch dich ausgelöst." },
      { q: "Mein Fortschritt ist weg.", a: "Die Daten liegen nur lokal auf dem Gerät; beim Löschen der App werden sie entfernt. Ein Geräte-Backup kann sie wiederherstellen." },
    ],
  },
  {
    slug: "kerfmate",
    name: "KerfMate",
    category: "Zuschnittplanung · Werkzeug",
    accent: "#5DE2B3",
    icon: "Ruler",
    iconImage: "/studio-assets/kerfmate/icon.webp",
    screenshots: [1, 2, 3, 4, 5, 6].map((i) => `/studio-assets/kerfmate/shot-${i}.webp`),
    tagline: "Weniger Verschnitt. Mehr bauen.",
    description:
      "KerfMate verwandelt rechteckige Teilelisten in klare, materialschonende Schnittpläne für Platten und Leisten – mit Schnittfuge, Randbeschnitt, Faserrichtung, Kosten und Reststücken.",
    features: [
      "2D-Plattenplanung für Sperrholz, MDF und andere rechteckige Platten",
      "1D-Planung für Leisten, Kantholz, Profile und Stangenmaterial",
      "Berücksichtigt Schnittfuge, Randbeschnitt, Drehsperre und Faserrichtung",
      "Grafische Pläne, Materialnutzung, Referenz-Schnittkanten und ehrlich ausgewiesene nicht platzierte Teile",
      "Metrisch und Imperial inklusive Bruchmaßen",
      "Reststück-Inventar, CSV-Import sowie PDF-, CSV-, SVG- und JSON-Export mit Pro",
      "Sechs Sprachen (EN, DE, ES, FR, IT, PT-BR); native iPhone- und iPad-App",
    ],
    flags: { local: true, exports: true, imports: true },
    supportEmail: "info@viralcrew.de",
    privacyIntro:
      "KerfMate erhebt keine Daten. Projekte und Pläne bleiben auf deinem Gerät („Keine Daten erhoben / Data Not Collected“).",
    importNote:
      "CSV- und JSON-Dateien werden ausschließlich nach deiner Auswahl lokal gelesen und nicht hochgeladen.",
    disclaimer:
      "KerfMate erstellt praktische, materialschonende Layouts und verspricht keine mathematisch optimale Lösung. Version 1.0 plant rechteckige Teile und gerade Schnitte. Referenz-Schnittkanten sind Koordinaten, keine sichere Schnittreihenfolge oder Maschinenanweisung. Lege selbst eine sichere Reihenfolge fest und prüfe Maße sowie Maschinensicherheit vor jedem Zuschnitt. Die App ersetzt keine fachgerechte Arbeitsvorbereitung oder Sicherheitsunterweisung.",
    pricing: {
      proName: "KerfMate Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "1 Projekt mit bis zu 15 Teilen",
        "2D-/1D-Kernplanung",
        "Schnittfuge, Rand, Faser & Rotation",
        "Materialnutzung & nicht platzierte Teile",
      ],
      proIncludes: [
        "Unbegrenzte Projekte & Teile",
        "Reststück-Inventar",
        "CSV-Import",
        "Varianten & Duplikate",
        "PDF-, CSV-, SVG- & JSON-Export",
      ],
    },
    faq: [
      { q: "Ist der Plan garantiert optimal?", a: "Nein. Rechteck-Packung ist ein komplexes Optimierungsproblem. KerfMate erstellt schnell einen praktischen, materialschonenden Plan – prüfe ihn vor dem Zuschnitt." },
      { q: "Welche Materialien kann ich planen?", a: "Rechteckige Platten (Sperrholz, MDF …) und lineares Material (Leisten, Profile, Kantholz). Version 1.0 plant gerade Schnitte und rechteckige Teile." },
      { q: "Werden meine Projekte hochgeladen?", a: "Nein. Projekte, Teile, Pläne und Reststücke bleiben lokal auf dem Gerät." },
      { q: "Kann ich Imperialmaße nutzen?", a: "Ja, metrisch und imperial inklusive gängiger Brüche." },
      { q: "Was passiert beim Export?", a: "PDF, CSV, SVG oder JSON werden lokal erstellt; die Datei wird erst übergeben, wenn du im Apple-Teilen-Menü ein Ziel auswählst." },
      { q: "Was enthält Pro?", a: "Unbegrenzte Projekte & Teile, Reststück-Inventar, CSV-Import, Varianten und professionelle Exporte. Apple zeigt den verbindlichen Preis." },
      { q: "Wie kündige ich Pro?", a: "iOS-Einstellungen → [dein Name] → Abonnements. „Käufe wiederherstellen“ mit derselben Apple-ID." },
    ],
  },
  {
    slug: "crumbcost",
    name: "CrumbCost",
    category: "Rezeptkosten & Preise · Food/Business",
    accent: "#E2844C",
    icon: "ChefHat",
    iconImage: "/studio-assets/crumbcost/icon.webp",
    screenshots: [1, 2, 3, 4, 5, 6].map((i) => `/studio-assets/crumbcost/shot-${i}.webp`),
    tagline: "Kenne die echten Kosten. Kalkuliere mit Gewinn.",
    description:
      "CrumbCost berechnet echte Chargen- und Stückkosten aus Zutaten, Arbeit, Energie, Verpackung und Gemeinkosten und hilft kleinen Backgeschäften, mit Marge oder Aufschlag sicher zu kalkulieren.",
    features: [
      "Zentrale Zutatenbibliothek mit Packungsgrößen, Einheiten, optionaler Dichte und Preisverlauf",
      "Rezepte und wiederverwendbare Unterrezepte mit Batch-/Portionsskalierung",
      "Zutaten-, Arbeits-, Energie-, Verpackungs-, sonstige und Gemeinkosten getrennt ausgewiesen",
      "Stückkosten, Preisvorschlag, Gewinn und Bruttomarge per Marge oder Aufschlag",
      "Varianten, Aufträge, Produktionsmengen, Termine und Status",
      "Mehrere Betriebsprofile, Währungen und Stundensätze",
      "Nutzerinitiierte PDF-, CSV- und JSON-Exporte über Apples Teilen-Menü · komplett offline",
    ],
    flags: { local: true, exports: true },
    supportEmail: "info@viralcrew.de",
    privacyIntro:
      "CrumbCost erhebt keine Daten („Keine Daten erhoben / Data Not Collected“). Alle Rezepte, Zutaten und Kosten bleiben lokal auf deinem Gerät.",
    disclaimer:
      "CrumbCost liefert unverbindliche Schätzwerte auf Basis der eingegebenen Preise und Annahmen. Die App ist keine Nährwert-, Allergen-, Steuer- oder Rechtsberatung. Nutzer müssen Eingaben, Steuern, Kennzeichnungspflichten und Verkaufspreise selbst prüfen.",
    pricing: {
      proName: "CrumbCost Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Bis zu 3 Rezepte",
        "Zutatenbibliothek (Einheiten, Dichte, Preisverlauf)",
        "Kostenbausteine & Preis per Marge/Aufschlag",
        "Bestehende Daten bleiben bearbeitbar",
      ],
      proIncludes: [
        "Unbegrenzte Rezepte & Unterrezepte",
        "Varianten & Preisverläufe",
        "Aufträge & Produktionsplanung",
        "Mehrere Profile & Währungen",
        "PDF-, CSV- & JSON-Export",
      ],
    },
    faq: [
      { q: "Werden meine Daten hochgeladen?", a: "Nein. Zutaten, Rezepte und Kosten bleiben lokal auf dem Gerät." },
      { q: "Was ist der Unterschied zwischen Marge und Aufschlag?", a: "Aufschlag rechnet auf die Kosten auf (z. B. +150 %); Marge ist der Gewinnanteil am Verkaufspreis. CrumbCost zeigt beide klar getrennt." },
      { q: "Wie funktionieren Unterrezepte, Einheiten und Dichten?", a: "Unterrezepte lassen sich in anderen Rezepten wiederverwenden; optionale Dichten ermöglichen sicheres Umrechnen zwischen Gewicht und Volumen." },
      { q: "Sind die Preise und Kosten verbindlich?", a: "Nein. CrumbCost liefert unverbindliche Schätzwerte – prüfe Eingaben, Steuern, Kennzeichnungspflichten und Verkaufspreise selbst." },
      { q: "Wie sichere oder exportiere ich meine Daten?", a: "Über PDF-, CSV- oder JSON-Export im Apple-Teilen-Menü – nur durch dich ausgelöst." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und stelle sicher, dass du mit derselben Apple-ID angemeldet bist." },
      { q: "Wie kündige ich und wie lösche ich meine Daten?", a: "Abo über iOS-Einstellungen → [dein Name] → Abonnements. Deine Daten werden beim Löschen der App vollständig entfernt." },
    ],
  },
  {
    slug: "spoolmargin",
    name: "SpoolMargin",
    category: "3D-Druck-Kalkulation · Business",
    accent: "#31D7B5",
    icon: "Package",
    iconImage: "/studio-assets/spoolmargin/icon.webp",
    screenshots: [1, 2, 3, 4, 5, 6].map((i) => `/studio-assets/spoolmargin/shot-${i}.webp`),
    tagline: "Kosten kennen. Marge sichern.",
    description:
      "SpoolMargin kalkuliert Material, Strom, Maschinenverschleiß, Arbeit, Verpackung, feste Gebühren und Fehlerrisiko zu einem profitablen 3D-Druck-Angebot – privat und offline.",
    features: [
      "FDM- und Resin-Druckerprofile mit Strom- und Maschinenkosten",
      "PLA, PETG, ABS, ASA, TPU, Nylon, Resin und eigene Materialien",
      "Mehrere Materialien je Auftrag, Serienmengen und automatische Bestandsabbuchung beim Abschluss",
      "Zielmarge oder Aufschlag, empfohlener Stückpreis, Gesamtangebot und voraussichtlicher Gewinn",
      "Editierbarer lokaler Import von Slicer-Kommentaren aus G-code (Cura, PrusaSlicer, OrcaSlicer, Bambu Studio)",
      "Auftragshistorie, Gewinnübersicht und optionale lokale Mindestbestand-Hinweise",
      "Kundengerechte PDF-Angebote (ohne interne Kosten/Gewinn), CSV-Berichte und JSON-Backup",
    ],
    flags: { local: true, exports: true, imports: true, reminders: true },
    supportEmail: "info@viralcrew.de",
    privacyIntro:
      "SpoolMargin erhebt keine Daten („Keine Daten erhoben / Data Not Collected“). Drucker, Materialien, Aufträge und Angebote bleiben lokal auf deinem Gerät.",
    importNote:
      "Von dir gewählte G-code-Dateien werden ausschließlich lokal gelesen und nie hochgeladen. Slicer und Dialekte unterscheiden sich; importierte Zeit- und Materialwerte bleiben bearbeitbar und müssen vor einem Angebot geprüft werden. 3MF wird nicht automatisch importiert.",
    disclaimer:
      "SpoolMargin liefert unverbindliche Kalkulationsschätzungen und keine Steuer-, Buchhaltungs- oder Rechtsberatung. Nutzer müssen Steuern, Plattformgebühren, Materialschwankungen, Slicer-Schätzungen und Produktionsannahmen selbst prüfen. Slicer und G-code-Dialekte unterscheiden sich; importierte Werte bleiben bearbeitbar und müssen vor einem Angebot geprüft werden.",
    pricing: {
      proName: "SpoolMargin Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Bis zu 5 gespeicherte Aufträge",
        "2 Drucker & 3 Materialien",
        "Kernkalkulation (Kosten → Preis → Marge)",
        "Zielmarge oder Aufschlag",
      ],
      proIncludes: [
        "Unbegrenzte Aufträge, Drucker & Materialien",
        "Vollständige Gewinnauswertung",
        "Kundenfertige PDF-Angebote",
        "CSV-Berichte & JSON-Backup",
        "G-code-Import (Cura, Prusa, Orca, Bambu)",
      ],
    },
    faq: [
      { q: "Werden meine Dateien oder Daten hochgeladen?", a: "Nein. Alle Daten und die von dir gewählten G-code-Dateien bleiben lokal auf dem Gerät." },
      { q: "Die G-code-Werte fehlen oder wirken falsch.", a: "Slicer und Dialekte unterscheiden sich. Importierte Zeit-/Materialwerte bleiben bearbeitbar und müssen vor einem Angebot geprüft werden. 3MF wird nicht automatisch importiert." },
      { q: "Wie sichere ich meine Daten?", a: "Exportiere ein JSON-Backup über das Apple-Teilen-Menü und bewahre es sicher auf. In der App gibt es keinen automatischen Import/Restore." },
      { q: "Wie funktioniert die Bestandsabbuchung?", a: "Beim Abschluss eines Auftrags wird das genutzte Material automatisch abgebucht. Optionale lokale Mindestbestand-Hinweise erfordern eine iOS-Berechtigung." },
      { q: "Enthält das Kundenangebot meine internen Kosten?", a: "Nein. Kundengerechte PDF-Angebote zeigen keine internen Kosten oder Gewinne." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und stelle sicher, dass du mit derselben Apple-ID angemeldet bist." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "Über iOS-Einstellungen → [dein Name] → Abonnements. Bei Supportexporten bitte Kundendaten vorher anonymisieren." },
    ],
  },
  {
    slug: "tenancysnap",
    name: "TenancySnap",
    category: "Business / Produktivität",
    accent: "#126FC5",
    icon: "ClipboardCheck",
    iconImage: "/studio-assets/tenancysnap/icon.webp",
    hero: "/studio-assets/tenancysnap/hero.webp",
    tagline: "Jede Übergabe klar dokumentiert.",
    description:
      "TenancySnap führt bei Einzug, Auszug und Kontrollen Raum für Raum durch Zustände, Notizen, datierte Fotos, Zählerstände, Schlüssel und Kenntnisnahme-Unterschriften. Frühere Protokolle lassen sich vergleichen und professionelle PDF-, CSV- und JSON-Exporte erstellen – vollständig lokal und ohne Konto.",
    features: [
      "Wiederverwendbare Raum-Checklisten und eigene Pro-Vorlagen",
      "Zustandsstufen, Notizen sowie Vorher-/Nachher-Fotos mit Bildunterschrift",
      "Strom-, Gas- und Wasserzähler sowie Schlüsselanzahl",
      "Lokale Kenntnisnahme-Unterschriften",
      "Vergleich mit früherem Protokoll",
      "Mehrseitige PDF-Berichte mit Fotos, Zählern, Schlüsseln und Unterschriften",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "TenancySnap erhebt keine Daten (Data Not Collected). Objekte, Protokolle, komprimierte Fotos und Unterschriften bleiben ausschließlich im lokalen App-Speicher – kein Konto, kein Backend, kein Tracking, keine Werbung.",
    cameraNote:
      "Kamera und Fotomediathek werden ausschließlich nach einer aktiven Nutzeraktion verwendet; es findet kein automatischer Upload statt. Der angezeigte Fotozeitpunkt ist der Zeitpunkt, zu dem das Bild dem Protokoll hinzugefügt wurde. Wählst du im Apple-Teilen-Menü ein Ziel für einen Export, gilt für dieses Ziel dessen eigene Datenschutzerklärung.",
    supportNoteExtra:
      "Sende insbesondere keine Objekt-, Foto- oder Unterschriftsdaten unaufgefordert.",
    disclaimer:
      "TenancySnap dient nur der strukturierten Dokumentation. Die App ist keine Rechtsberatung oder zertifizierte Prüfung und garantiert weder Richtigkeit noch Beweiskraft. Alle Angaben prüfen und lokales Recht beachten. Unterschriften dokumentieren nur die Kenntnisnahme innerhalb des Protokolls und sind keine rechtliche Bestätigung durch TenancySnap.",
    pricing: {
      proName: "TenancySnap Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Ein Objekt und zwei Protokolle",
        "Integrierte Vorlage",
        "PDF mit kleinem TenancySnap-Hinweis",
      ],
      proIncludes: [
        "Unbegrenzte Objekte & Protokolle",
        "Eigene Vorlagen",
        "Protokoll-Vergleiche",
        "PDF ohne Hinweis",
        "CSV & vollständige JSON-Sicherung",
      ],
    },
    faq: [
      { q: "Wo werden meine Protokolle gespeichert?", a: "Ausschließlich lokal auf deinem Gerät. Es gibt kein Konto und kein Backend von uns." },
      { q: "Wie nutzt TenancySnap Kamera und Fotos?", a: "Kamera bzw. Fotomediathek werden nur nach deiner Aktion verwendet. Es gibt keinen automatischen Upload." },
      { q: "Welcher Zeitpunkt steht bei einem Foto?", a: "Der angezeigte Fotozeitpunkt ist der Moment, in dem das Bild dem Protokoll hinzugefügt wurde." },
      { q: "Was bedeuten die Unterschriften?", a: "Sie dokumentieren nur die Kenntnisnahme im Protokoll und sind keine rechtliche Bestätigung durch TenancySnap." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV und eine vollständige JSON-Sicherung – jeweils über das Teilen-Menü von Apple, nur durch dich ausgelöst." },
      { q: "Wie stelle ich eine JSON-Sicherung wieder her?", a: "Über die Wiederherstellungsfunktion in der App wählst du deine zuvor exportierte JSON-Datei aus." },
      { q: "Was umfasst die kostenlose Version?", a: "Ein Objekt, zwei Protokolle, die integrierte Vorlage und ein PDF mit kleinem Hinweis." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und stelle sicher, dass du mit derselben Apple-ID angemeldet bist." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → TenancySnap Pro." },
    ],
  },
  {
    slug: "ruckforge",
    name: "RuckForge",
    category: "Health & Fitness / Sport",
    accent: "#C8642A",
    icon: "Backpack",
    iconImage: "/studio-assets/ruckforge/icon.webp",
    hero: "/studio-assets/ruckforge/hero.webp",
    tagline: "Carry with purpose.",
    description:
      "RuckForge erfasst gewichtete Spaziergänge mit Vordergrund-GPS auf dem iPhone, Packlast, Pace, Höhe, Route, Ausrüstungs-Laufleistung und Wochenziele. PDF, CSV, GPX und JSON können exportiert und abgeschlossene Workouts optional in Apple Health geschrieben werden.",
    features: [
      "Vordergrund-Ruck-Tracking auf dem iPhone",
      "Pack- und Gear-Verwaltung mit Laufleistung",
      "Pace, Höhe und Route",
      "Wochenziele",
      "PDF-, CSV-, GPX- und JSON-Export",
      "Optionaler Apple-Health-Export (write-only)",
    ],
    flags: { local: true, exports: true, healthkit: true },
    privacyIntro:
      "RuckForge erhebt keine Daten (Data Not Collected). Route, Pack, Gear und Notizen bleiben lokal. ViralCrew erhält weder Routen noch Health-Daten.",
    disclaimer:
      "GPS-, Distanz-, Pace- und Höhenwerte sind Schätzungen. Keine Leistungs-, Verletzungspräventions- oder medizinischen Versprechen. RuckForge ist ein Trainingstagebuch und kein medizinischer Rat.",
    healthNote:
      "Apple Health ist standardmäßig aus und strikt write-only. Nach bewusster Aktivierung schreibt RuckForge ein abgeschlossenes Outdoor-Geh-Workout mit Start/Ende beziehungsweise Dauer, Geh-/Laufdistanz und Packgewicht als RuckForge-Metadatum. Die App liest keine Health-Daten und überträgt keine GPS-Route an Health.",
    locationNote:
      "Der Standort wird erst nach bewusstem Start eines Rucks und nur im Vordergrund aufgezeichnet; es gibt kein Hintergrundtracking und kein Watch-Target. Die Karte nutzt Apple MapKit und kann Kartenbilder über Apples iOS-Systemdienst laden. Route, Pack, Gear und Notizen bleiben lokal. Temporäre Exportdateien werden nach Teilen/Verwerfen bzw. Reset entfernt.",
    pricing: {
      proName: "RuckForge Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Fünf gespeicherte Rucks",
        "Zwei Packs",
        "Ein Gear-Element",
      ],
      proIncludes: [
        "Unbegrenzte Historie & Objekte",
        "Erweiterte Auswertung",
        "PDF-, CSV-, GPX- & JSON-Export",
      ],
    },
    faq: [
      { q: "Ich habe den Standort abgelehnt – was passiert?", a: "Ohne Standortfreigabe kann RuckForge Route, Distanz und Pace nicht aufzeichnen. Du kannst die Freigabe jederzeit in den iOS-Einstellungen erteilen." },
      { q: "Wird im Hintergrund getrackt?", a: "Nein. Die Aufzeichnung läuft ausschließlich im Vordergrund, nachdem du einen Ruck bewusst gestartet hast." },
      { q: "Wie genau ist das GPS?", a: "GPS-, Distanz-, Pace- und Höhenwerte sind Schätzungen und hängen von Empfang und Gerät ab." },
      { q: "Wie funktioniert die Apple-Health-Anbindung?", a: "Sie ist standardmäßig aus, optional und strikt write-only: RuckForge schreibt nur abgeschlossene Workouts und liest keine Health-Daten." },
      { q: "Wo liegen meine Daten?", a: "Route, Pack, Gear und Notizen bleiben lokal auf dem Gerät." },
      { q: "Wie sichere und stelle ich Daten wieder her?", a: "Über einen JSON-Export im Teilen-Menü; zur Wiederherstellung wählst du diese Datei in der App aus." },
      { q: "Was passiert mit Exportdateien?", a: "Exporte gehen nur an das von dir gewählte Ziel; temporäre Dateien werden nach Teilen/Verwerfen bzw. Reset entfernt." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → RuckForge Pro." },
    ],
  },
  {
    slug: "reformlog",
    name: "ReformLog",
    category: "Health & Fitness / Lifestyle",
    accent: "#C879D2",
    icon: "Activity",
    iconImage: "/studio-assets/reformlog/icon.webp",
    hero: "/studio-assets/reformlog/hero.webp",
    tagline: "Erinnere jede Klasse.",
    description:
      "ReformLog ist ein privates Reformer-Pilates-Journal für Dauer, Studio, Trainer, Feder-Settings, Bewegungen, RPE, Notizen, Wochenziele, Kalender und Trends. Optional lassen sich private Fortschrittsfotos hinzufügen.",
    features: [
      "Detaillierte Sessions (Studio, Trainer, Feder-Settings, RPE, Notizen)",
      "Wochenziel, Kalender, Minuten, Serien & Trends",
      "Private Fotos über den PhotosPicker",
      "Optionales Schreiben abgeschlossener Pilates-Workouts in Apple Health",
      "PDF-, CSV- & JSON-Export",
      "Vollständige lokale JSON-Wiederherstellung",
    ],
    flags: { local: true, exports: true, healthkit: true },
    privacyIntro:
      "ReformLog erhebt keine Daten (Data Not Collected). Journal und ausdrücklich gewählte Fotos liegen im geschützten lokalen App-Speicher – kein Konto, kein Backend, kein Tracking, keine Werbung.",
    disclaimer:
      "ReformLog ist ausschließlich ein persönliches Praxisjournal – kein Trainingsprogramm, Übungskatalog, Video-Coach, System zur Formanalyse, Reha-Werkzeug oder medizinischer Rat. Die App kopiert oder verordnet keine Klassen.",
    healthNote:
      "Apple Health ist standardmäßig aus und strikt write-only. Nach bewusster Aktivierung schreibt ReformLog ein abgeschlossenes Indoor-Pilates-Workout mit Start/Ende beziehungsweise Dauer sowie Anstrengung und Studio als ReformLog-Metadaten. Die App liest keine Health-Daten.",
    exportNote:
      "Exporte (PDF, CSV, JSON) werden ausschließlich durch dich über das Apple-Teilen-Menü ausgelöst; private Fotos sind nie Bestandteil dieser Exporte und bewusst nicht in JSON-Sicherungen enthalten. App-eigene temporäre Exportdateien werden nach dem Teilen oder Verwerfen gelöscht. „Alle lokalen Daten löschen“ entfernt Journal, Fotos, Wiederherstellungsdateien und temporäre Exporte.",
    pricing: {
      proName: "ReformLog Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Zehn gespeicherte Sessions",
      ],
      proIncludes: [
        "Unbegrenzter Verlauf",
        "Private Fortschrittsfotos",
        "Tiefere Fortschrittsansichten",
        "PDF-, CSV- & JSON-Export",
      ],
    },
    faq: [
      { q: "Wo werden mein Journal und meine Fotos gespeichert?", a: "Im geschützten lokalen App-Speicher deines Geräts. Es gibt kein Konto und kein Backend." },
      { q: "Wie funktionieren die privaten Fotos?", a: "Fotos wählst du über den PhotosPicker aus. Sie bleiben lokal und sind nie Teil von Exporten." },
      { q: "Wie ist der Health-Zugriff geregelt?", a: "Apple Health ist standardmäßig aus und strikt write-only: nur abgeschlossene Workouts werden geschrieben, keine Daten gelesen." },
      { q: "Wohin gehen meine Exporte?", a: "PDF/CSV/JSON verlassen die App nur über das von dir gewählte Ziel im Apple-Teilen-Menü." },
      { q: "Wie sichere und stelle ich mein Journal wieder her?", a: "Über einen JSON-Export; zur Wiederherstellung wählst du die Datei in der App aus." },
      { q: "Warum sind meine Fotos nicht im Backup?", a: "JSON-Sicherungen enthalten bewusst keine Fotos, damit private Bilder privat bleiben." },
      { q: "Wie lösche ich alle lokalen Daten?", a: "„Alle lokalen Daten löschen“ entfernt Journal, Fotos, Wiederherstellungsdateien und temporäre Exporte." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → ReformLog Pro." },
    ],
  },
  {
    slug: "quiltyield",
    name: "QuiltYield",
    category: "Werkzeug / Lifestyle",
    accent: "#E83C79",
    icon: "Scissors",
    iconImage: "/studio-assets/quiltyield/icon.webp",
    hero: "/studio-assets/quiltyield/hero.webp",
    tagline: "Kenne deinen Stoffbedarf vor dem Zuschnitt.",
    description:
      "QuiltYield berechnet Rückseite, Vlies, Binding und Block-Zuschnittmaße und legt Patchworkteile materialsparend auf vorhandenen Stoffen aus. Berücksichtigt werden Nahtzugabe, Überstand, mehrteilige Rückseiten, Musterrapport, Stoffbreite, Mengen, Drehung und gerichtete Muster.",
    features: [
      "Rückseiten- und Vliesmaße",
      "Mehrteilige Rückseiten mit Verbindungszugabe",
      "Musterrapport & gerichtete Muster",
      "Binding, Überlappung & Streifen",
      "Fertig-zu-Zuschnittmaß & visuelle Layouts mit Nutzung/Warnungen",
      "Lokales Stofflager · PDF-, CSV-, SVG- & JSON-Export",
    ],
    flags: { local: true, exports: true, imports: true },
    privacyIntro:
      "QuiltYield erhebt keine Daten (Data Not Collected). Projekte, Stoffe und Reste bleiben lokal – keine Kamera/Fotomediathek, keine Erinnerungen, kein HealthKit, keine KI, kein Game Center, kein Tracking, keine Werbung.",
    importNote:
      "Von dir gewählte CSV-Dateien werden ausschließlich lokal gelesen und nie hochgeladen.",
    disclaimer:
      "Alle Ergebnisse sind Planungsschätzungen. Vorwäsche, Einlaufen, Musterabgleich, Schrägschnitt, Stofffehler und Nähmethode können den tatsächlichen Stoffbedarf ändern. Maße, Nahtzugaben und Musterrichtung vor dem Schneiden prüfen.",
    pricing: {
      proName: "QuiltYield Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Ein Quilt mit bis zu 15 Teilen",
      ],
      proIncludes: [
        "Unbegrenzte Quilts & Teile",
        "Stofflager",
        "CSV-Import",
        "Quilt-Duplikate",
        "Professionelle Exporte (PDF, CSV, SVG, JSON)",
      ],
    },
    faq: [
      { q: "Metrisch oder imperial?", a: "Beides wird unterstützt; du kannst die Einheiten wählen." },
      { q: "Wie werden Nahtzugabe, Überstand und Musterrapport berücksichtigt?", a: "Alle drei fließen in Rückseiten-, Vlies- und Binding-Berechnungen sowie in die Layouts ein." },
      { q: "Werden gerichtete Muster beachtet?", a: "Ja. Drehung und gerichtete Muster werden bei der Auslage berücksichtigt." },
      { q: "Wo liegen meine Projekte?", a: "Projekte, Stoffe und Reste bleiben lokal auf dem Gerät." },
      { q: "Wie funktioniert der CSV-Import?", a: "Von dir gewählte CSV-Dateien werden nur lokal gelesen und nicht hochgeladen." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV, SVG und JSON über das Apple-Teilen-Menü." },
      { q: "Was umfasst die kostenlose Version?", a: "Ein Quilt mit bis zu 15 Teilen." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → QuiltYield Pro." },
    ],
  },
  {
    slug: "rotacourt",
    name: "RotaCourt",
    category: "Sport / Werkzeug",
    accent: "#35C0B5",
    icon: "Trophy",
    iconImage: "/studio-assets/rotacourt/icon.webp",
    hero: "/studio-assets/rotacourt/hero.webp",
    tagline: "Faire Padel- und Pickleball-Turniere in Sekunden.",
    description:
      "RotaCourt erstellt Americano-, Mexicano- und Jeder-gegen-jeden-Spielpläne, verteilt Partner, Gegner und Pausen fair, erfasst Resultate direkt am Platz und erzeugt Tabelle sowie PDF-/CSV-Berichte.",
    features: [
      "Padel & Pickleball",
      "Americano, Mexicano & feste Round-Robin-Teams",
      "Gerade und ungerade Gruppen bei Americano/Mexicano",
      "Mehrere Plätze und faire Pausen",
      "Live-Ergebnisse, Rangliste, Tiebreaks & Verlauf",
      "PDF-/CSV-/JSON-Export · sechs Sprachen · iPhone & iPad · offline",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "RotaCourt erhebt keine Daten (Data Not Collected). Namen, Pläne und Ergebnisse liegen ausschließlich lokal im App-Container – kein Konto, kein Backend, kein Tracking, keine Werbung, kein Cloud-Sync.",
    disclaimer:
      "Resultate werden vom Organisator eingegeben und müssen vor offizieller Veröffentlichung geprüft werden. RotaCourt ist kein Verbands-, Schiedsrichter-, Steuer- oder Rechtsdienst und garantiert keine sportrechtliche Anerkennung.",
    supportNoteExtra:
      "Sende insbesondere keine Personen- oder Turnierdaten unaufgefordert.",
    pricing: {
      proName: "RotaCourt Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Ein gespeichertes Americano-Turnier",
        "Maximal acht Personen",
      ],
      proIncludes: [
        "Unbegrenzte Turniere & Personen",
        "Alle Formate (Americano, Mexicano, Round-Robin)",
        "Verlauf",
        "PDF-, CSV- & JSON-Export",
      ],
    },
    faq: [
      { q: "Welche Sportarten und Formate werden unterstützt?", a: "Padel und Pickleball mit Americano, Mexicano und festen Round-Robin-Teams." },
      { q: "Funktionieren ungerade Gruppen?", a: "Ja, bei Americano und Mexicano werden gerade und ungerade Gruppen unterstützt." },
      { q: "Was gilt bei festen Teams?", a: "Feste Round-Robin-Teams benötigen eine gerade Personenzahl." },
      { q: "Wie entstehen Mexicano-Folgerunden?", a: "Jede Folgerunde wird erst nach Abschluss der aktuellen Runde aus dem aktuellen Spielpunkte-Stand erzeugt." },
      { q: "Wie ist das Free-Limit, und hilft Archivieren?", a: "Free erlaubt ein Americano-Turnier mit bis zu acht Personen. Archivieren setzt das Free-Limit nicht zurück." },
      { q: "Wo liegen meine Daten?", a: "Namen, Pläne und Ergebnisse liegen ausschließlich lokal im App-Container." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV und JSON über das Apple-Teilen-Menü." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → RotaCourt Pro." },
    ],
  },
  {
    slug: "tenttrail",
    name: "TentTrail",
    category: "Spiele / Puzzle / Casual",
    accent: "#3FA34D",
    icon: "Tent",
    iconImage: "/studio-assets/tenttrail/icon.webp",
    hero: "/studio-assets/tenttrail/hero.webp",
    tagline: "Tägliche Zelte-&-Bäume-Logik – eindeutig, ruhig, ohne Raten.",
    description:
      "TentTrail ist ein eigenständiges prozedurales Logikspiel: Neben jedem Baum steht genau ein Zelt, Zelte berühren sich auch diagonal nicht, und Zeilen-/Spaltenzahlen müssen stimmen. Enthalten sind Daily, Wochenexpedition, 6×6/8×8/10×10-Levelpfad, erklärbare Hinweise, Streak-Kalender, spielbares Offline-Archiv und optionales Apple Game Center.",
    features: [
      "Täglich erzeugte Rätsel",
      "Wochenexpedition",
      "Drei Größen (6×6, 8×8, 10×10) & Levelpfad",
      "Erklärbare Hinweise",
      "Streak-Kalender & Offline-Archiv",
      "Optionales Apple Game Center",
    ],
    flags: { local: true, gamecenter: true, exports: true },
    privacyIntro:
      "TentTrail erhebt keine Daten (Data Not Collected). Rätselstände, Serien, Spracheinstellungen und lokale Sicherungen liegen im App-Container – kein Konto, kein Backend, kein Tracking, keine Werbung.",
    gamecenterNote:
      "TentTrail fordert beim App-Start die Authentifizierung über Apples Game Center an. Wenn der Nutzer dort angemeldet ist, sendet die App beim Abschluss einer Wochenexpedition automatisch einen aus Spielzeit und verwendeten Hinweisen berechneten Score an Apples Weekly-Rangliste. Kontoverarbeitung und Rangliste liegen bei Apple. ViralCrew betreibt dafür keinen Server und erhält kein Spielerprofil.",
    exportNote:
      "Daten verlassen das Gerät nur, wenn du ein Ergebnis als Text teilst oder eine JSON-Sicherung exportierst – jeweils über das Apple-Teilen-Menü und nur durch dich ausgelöst.",
    supportNoteExtra:
      "Nenne bei TentTrail bitte zusätzlich dein Gerätemodell und sende keine app-internen Daten unaufgefordert.",
    disclaimer:
      "TentTrail ist ein Unterhaltungsspiel und kein diagnostisches, medizinisches oder pädagogisches Leistungsversprechen. Game-Center-Ranglisten sind optional; Verfügbarkeit und Kontoverarbeitung liegen bei Apple.",
    pricing: {
      proName: "TentTrail Pro",
      noAmounts: true,
      trialDays: 7,
      freeIncludes: [
        "Daily",
        "Pfadlevel 1–12",
        "Sieben spielbare Archivtage",
      ],
      proIncludes: [
        "Unbegrenzter kompletter Pfad",
        "Weekly (Wochenexpedition)",
        "365 spielbare Archivtage",
      ],
    },
    faq: [
      { q: "Wie sind die Regeln?", a: "Neben jedem Baum steht genau ein Zelt, Zelte berühren sich auch diagonal nicht, und die Zeilen-/Spaltenzahlen müssen stimmen." },
      { q: "Sind die Rätsel immer eindeutig lösbar?", a: "Ja. Jedes Board wird lokal auf eine gültige eingebettete Lösung, genau eine mögliche Zeltbelegung und einen vollständigen Weg geprüft; Hinweise sind erklärbar." },
      { q: "Was gibt es bei Daily, Weekly, Pfad und Archiv?", a: "Ein tägliches Rätsel, eine Wochenexpedition, einen Levelpfad in drei Größen und ein spielbares Offline-Archiv." },
      { q: "Wo liegt mein Fortschritt?", a: "Rätselstände, Serien und lokale Sicherungen liegen im App-Container; du kannst eine JSON-Sicherung teilen." },
      { q: "Wie funktioniert Game Center?", a: "Optional. Verfügbarkeit und Kontoverarbeitung liegen bei Apple; ViralCrew erhält kein Spielerprofil." },
      { q: "Was ist in Free und Pro enthalten?", a: "Free: Daily, Pfadlevel 1–12 und sieben Archivtage. Pro: kompletter Pfad, Weekly und 365 Archivtage." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
      { q: "Ich möchte einen Fehler melden – was hilft?", a: "Nenne uns bitte dein Gerätemodell, die App-/iOS-Version und eine kurze Beschreibung an info@viralcrew.de." },
      { q: "Wie verwalte oder kündige ich mein Abo?", a: "iOS-Einstellungen → [dein Name] → Abonnements → TentTrail Pro." },
    ],
  },
  {
    slug: "hoofledger",
    name: "HoofLedger",
    category: "Business / Produktivität",
    accent: "#E0A458",
    icon: "Hammer",
    iconImage: "/studio-assets/hoofledger/icon.webp",
    hero: "/studio-assets/hoofledger/hero.webp",
    tagline: "Das private Außenbüro für selbstständige Hufschmiede.",
    description:
      "HoofLedger verwaltet Kunden-, Hof- und Pferde-Datensätze, wiederkehrende Besuchszyklen, Service-Historie, Kilometer, PDF-Rechnungen, Zahlungsstatus und lokale Business-Reports – ganz ohne Konto, Backend, Werbung oder Tracking. Zahlungen werden nicht verarbeitet.",
    features: [
      "Kunden-, Hof- & Pferde-Datensätze",
      "Wiederkehrende Besuchszyklen & Service-Historie",
      "Anfahrt/Kilometer erfassen",
      "PDF-Rechnungen & Zahlungsstatus",
      "Lokale Business-Reports",
      "JSON- & CSV-Export",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "HoofLedger erhebt keine Daten (Data Not Collected). Kunden-, Hof- und Pferde-Datensätze bleiben im lokalen App-Container – kein Konto, kein Backend, keine Werbung, kein Tracking, kein Kontaktimport, keine Fern-Synchronisation, keine Hintergrund-Ortung; es werden keine Zahlungen verarbeitet.",
    disclaimer:
      "HoofLedger ist eine Organisationshilfe – keine Buchhaltungs-, Steuer-, tierärztliche oder Rechtsberatung. Nutzer müssen Rechnungen, Steuern und alle Entscheidungen zur Tierpflege selbst prüfen.",
    supportNoteExtra: "Sende keine Namen, Adressen, Rechnungen oder Tiergesundheits-Notizen.",
    pricing: {
      proName: "HoofLedger Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Kern-Datensätze (Kunde/Hof/Pferd)", "Besuchs- & Service-Historie", "Lokale JSON-/CSV-Portabilität", "Keine Werbung"],
      proIncludes: ["Unbegrenzte Datensätze", "PDF-Rechnungen & Zahlungsstatus", "Lokale Business-Reports", "Vollständige Exporte"],
    },
    faq: [
      { q: "Werden meine Daten übertragen?", a: "Nein. Alle Datensätze bleiben lokal im App-Container. Es gibt kein Konto und kein Backend von uns." },
      { q: "Verarbeitet HoofLedger Zahlungen?", a: "Nein. HoofLedger dokumentiert nur Zahlungsstatus; es werden keine Zahlungen abgewickelt." },
      { q: "Wie exportiere ich?", a: "PDF, CSV oder JSON über Apples Teilen-Menü – nur durch dich ausgelöst." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "bendledger",
    name: "BendLedger",
    category: "Werkzeug / Business",
    accent: "#26D4C2",
    icon: "Ruler",
    iconImage: "/studio-assets/bendledger/icon.webp",
    hero: "/studio-assets/bendledger/hero.webp",
    tagline: "Transparente Blechbiege-Mathematik – offline.",
    description:
      "BendLedger berechnet Biegezugabe, Biegeabzug, Rückzug und gestreckte Länge, entwickelt Kegel/Frustum, plant Abkantpressen-Abläufe und verwaltet Material- und Maschinenprofile, Projekte sowie PDF-/CSV-/JSON-Export – lokal und ohne Konto.",
    features: [
      "Biegezugabe, -abzug, Rückzug & gestreckte Länge",
      "Kegel-/Frustum-Abwicklung",
      "Abkantpressen-Planung",
      "Material- & Maschinenprofile",
      "Projekte",
      "PDF-, CSV- & JSON-Export",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "BendLedger erhebt keine Daten (Data Not Collected). Projekte, Material-/Maschinenprofile und Berechnungen bleiben lokal – kein Konto, kein Backend, keine Werbung, kein Tracking.",
    disclaimer:
      "Alle Ergebnisse sind Planungsschätzungen. Material, Werkzeug, Faserrichtung, Rückfederung, Maschinenzustand, Testbiegung und Sicherheit vor der Fertigung prüfen.",
    supportNoteExtra: "Sende keine vertraulichen Werkstattzeichnungen.",
    pricing: {
      proName: "BendLedger Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Kernberechnungen (Biegezugabe/-abzug/Rückzug)", "Ein Projekt", "Lokale JSON-Portabilität", "Keine Werbung"],
      proIncludes: ["Unbegrenzte Projekte", "Frustum-Abwicklung & Abkantplanung", "Material- & Maschinenprofile", "PDF-, CSV- & JSON-Export"],
    },
    faq: [
      { q: "Sind die Ergebnisse verbindlich?", a: "Nein. Es sind Planungsschätzungen; prüfe Material, Werkzeug, Rückfederung und mache eine Testbiegung." },
      { q: "Werden meine Projekte hochgeladen?", a: "Nein. Alles bleibt lokal auf dem Gerät." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV und JSON über Apples Teilen-Menü." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "cutmetric",
    name: "CutMetric",
    category: "Werkzeug / Business",
    accent: "#5CDBFF",
    icon: "Drill",
    iconImage: "/studio-assets/cutmetric/icon.webp",
    hero: "/studio-assets/cutmetric/hero.webp",
    tagline: "Zerspanungs-Rechner: Vorschub, Drehzahl, Gewinde – offline.",
    description:
      "CutMetric rechnet transparent Vorschub/Drehzahl, MRR, Gewindebohrer-, Lochkreis-, Position-, Bohrspitzen- und Kegel-Mathematik und speichert Werkzeuge, Materialien, Maschinen und Setups mit PDF-/CSV-/JSON-Export – lokal und ohne Konto.",
    features: [
      "Vorschub/Drehzahl & Materialabtrag (MRR)",
      "Gewindebohrer-, Lochkreis- & Position-Mathematik",
      "Bohrspitzen- & Kegel-Berechnung",
      "Gespeicherte Werkzeuge, Materialien & Maschinen",
      "Setups",
      "PDF-, CSV- & JSON-Export",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "CutMetric erhebt keine Daten (Data Not Collected). Werkzeuge, Materialien, Maschinen und Setups bleiben lokal – kein Konto, kein Backend, keine Werbung, kein Tracking.",
    disclaimer:
      "CutMetric liefert konservative Planungs-Startwerte – keine G-code- oder Maschinenanweisungen. Herstellerdaten, Maschinengrenzen, Werkstückspannung und einen kontrollierten Testschnitt vor dem Zerspanen prüfen.",
    supportNoteExtra: "Sende keine vertraulichen Programme oder Zeichnungen.",
    pricing: {
      proName: "CutMetric Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Kernrechner (Vorschub/Drehzahl, MRR)", "Begrenzte gespeicherte Werkzeuge/Materialien", "Lokale JSON-Portabilität", "Keine Werbung"],
      proIncludes: ["Unbegrenzte Werkzeuge/Materialien/Maschinen", "Alle Rechner (Gewinde, Lochkreis, Position …)", "Setups", "PDF-, CSV- & JSON-Export"],
    },
    faq: [
      { q: "Sind die Werte Maschinenanweisungen?", a: "Nein. Es sind konservative Startwerte – prüfe Herstellerdaten und mache einen kontrollierten Testschnitt." },
      { q: "Werden meine Daten hochgeladen?", a: "Nein. Werkzeuge, Materialien und Setups bleiben lokal." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV und JSON über Apples Teilen-Menü." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "fluencytap",
    name: "FluencyTap",
    category: "Bildung / Produktivität",
    accent: "#FF4A7A",
    icon: "Languages",
    iconImage: "/studio-assets/fluencytap/icon.webp",
    hero: "/studio-assets/fluencytap/hero.webp",
    tagline: "Privates Sprechtraining – ohne Aufnahme.",
    description:
      "FluencyTap ist privates Sprechtraining ohne Aufnahme: Timer-Prompts, freiwillige Flow-Taps, private Selbstbewertungen, mehrsprachige eigene Prompts, Phrasenkarten mit Spaced Review, ehrliche Trends und PDF-/CSV-/JSON-Export.",
    features: [
      "Timer-Prompts",
      "Freiwillige Flow-Taps",
      "Private Selbstbewertungen",
      "Mehrsprachige eigene Prompts",
      "Phrasenkarten mit Spaced Review",
      "Ehrliche Trends & PDF-/CSV-/JSON-Export",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "FluencyTap erhebt keine Daten (Data Not Collected). Kein Mikrofon, keine Spracherkennung. Alle Aufzeichnungen bleiben lokal – kein Konto, kein Backend, keine Werbung, keine Analyse, kein Tracking.",
    disclaimer:
      "FluencyTap ist ausschließlich selbstgesteuertes Übungstool. Die App hört nicht zu, nimmt nicht auf, transkribiert nicht, bewertet keine Aussprache und zertifiziert keine Fähigkeiten.",
    pricing: {
      proName: "FluencyTap Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Timer-Prompts & Flow-Taps", "Private Selbstbewertungen", "Lokale JSON-Portabilität", "Keine Werbung"],
      proIncludes: ["Unbegrenzte eigene Prompts", "Phrasenkarten mit Spaced Review", "Ehrliche Trends", "PDF-, CSV- & JSON-Export"],
    },
    faq: [
      { q: "Nimmt FluencyTap meine Stimme auf?", a: "Nein. Es gibt kein Mikrofon und keine Spracherkennung – die App hört nicht zu und nimmt nicht auf." },
      { q: "Wo liegen meine Daten?", a: "Alle Aufzeichnungen bleiben lokal auf dem Gerät." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV und JSON über Apples Teilen-Menü." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "aerocelllog",
    name: "AeroCellLog",
    category: "Werkzeug / Hobby",
    accent: "#21D1A8",
    icon: "Plane",
    iconImage: "/studio-assets/aerocelllog/icon.webp",
    hero: "/studio-assets/aerocelllog/hero.webp",
    tagline: "RC-Flug-, LiPo- und Wartungslog – offline.",
    description:
      "AeroCellLog ist ein Offline-Log für RC-Flüge, LiPo-/Akkus und Wartung mit Beobachtungen pro Zelle, Trends, Multi-Pack-Flugtimer, QR-Label-PDF, CSV-/JSON-Export und lokalen Erinnerungen.",
    features: [
      "Flug-, LiPo-/Akku- & Wartungslog",
      "Beobachtungen pro Zelle & Trends",
      "Multi-Pack-Flugtimer",
      "QR-Label-PDF",
      "CSV- & JSON-Export",
      "Lokale Erinnerungen",
    ],
    flags: { local: true, exports: true, reminders: true },
    privacyIntro:
      "AeroCellLog erhebt keine Daten (Data Not Collected). Flüge, Akkus und Wartung bleiben lokal – kein Konto, kein Backend, keine Werbung, kein Tracking, keine Standortberechtigung.",
    disclaimer:
      "AeroCellLog dient nur der Dokumentation – keine Batterie-Zustandsdiagnose, Sicherheitszertifizierung oder Ausfallvorhersage. Folge stets den Herstellerangaben.",
    pricing: {
      proName: "AeroCellLog Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Kern-Flug- & Akku-Log", "Multi-Pack-Flugtimer", "Lokale JSON-Portabilität", "Keine Werbung"],
      proIncludes: ["Unbegrenzte Einträge", "Beobachtungen pro Zelle & Trends", "QR-Label-PDF", "CSV- & JSON-Export"],
    },
    faq: [
      { q: "Diagnostiziert die App meinen Akku?", a: "Nein. AeroCellLog dokumentiert nur; es gibt keine Zustandsdiagnose oder Ausfallvorhersage. Folge den Herstellerangaben." },
      { q: "Wird mein Standort genutzt?", a: "Nein. Es gibt keine Standortberechtigung. Alle Daten bleiben lokal." },
      { q: "Welche Exporte gibt es?", a: "QR-Label-PDF, CSV und JSON über Apples Teilen-Menü." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "seamshift",
    name: "SeamShift",
    category: "Werkzeug / Lifestyle",
    accent: "#8F6BEC",
    icon: "Shirt",
    iconImage: "/studio-assets/seamshift/icon.webp",
    hero: "/studio-assets/seamshift/hero.webp",
    tagline: "Privates Schnittmuster-Anpassungs-Arbeitsblatt.",
    description:
      "SeamShift ist ein privates, offline Schnittmuster-Anpassungs-Arbeitsblatt mit transparenten Formeln, pseudonymen Maßprofilen, visuellen Schritten und PDF-/CSV-/JSON-Export.",
    features: [
      "Transparente Anpassungs-Formeln",
      "Pseudonyme Maßprofile",
      "Visuelle Schritte",
      "PDF-, CSV- & JSON-Export",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "SeamShift erhebt keine Daten (Data Not Collected). Pseudonyme Maßprofile und Anpassungen bleiben lokal – kein Konto, kein Backend, keine Werbung, kein Tracking.",
    disclaimer:
      "Ergebnisse sind Planungs-Arbeitsblätter, keine Passform-Garantie. Folge der Schnittmuster-Anleitung und nähe ein Probeteil, bevor du den finalen Stoff zuschneidest.",
    pricing: {
      proName: "SeamShift Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Kern-Anpassungen", "Ein Maßprofil", "Lokale JSON-Portabilität", "Keine Werbung"],
      proIncludes: ["Unbegrenzte Profile & Anpassungen", "Visuelle Schritte", "PDF-, CSV- & JSON-Export"],
    },
    faq: [
      { q: "Garantiert SeamShift die Passform?", a: "Nein. Es sind Planungs-Arbeitsblätter. Nähe vor dem finalen Zuschnitt ein Probeteil." },
      { q: "Wo liegen meine Maße?", a: "Pseudonyme Maßprofile bleiben lokal auf dem Gerät." },
      { q: "Welche Exporte gibt es?", a: "PDF, CSV und JSON über Apples Teilen-Menü." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "doseloom",
    name: "DoseLoom",
    category: "Gesundheit & Fitness / Lifestyle",
    accent: "#1AA6B0",
    icon: "Syringe",
    iconImage: "/studio-assets/doseloom/icon.webp",
    hero: "/studio-assets/doseloom/hero.webp",
    tagline: "Dein privates GLP-1-Routine-Log – Beobachtungen, nie Behandlungsempfehlung.",
    description:
      "DoseLoom ist ein privates, local-first Routine-Log für iPhone und iPad (iOS 17+): schnelles Logging, manuelles Inventar, lokale Erinnerungen, Verlauf, optionales read-only Apple-Health-Gewicht und PhotosPicker-Fotos. Kein Konto, kein Backend, keine Werbung, keine Analyse.",
    features: [
      "Schnelles Routine-Logging",
      "Manuelles Inventar",
      "Lokale Erinnerungen & Verlauf",
      "Optional read-only Apple-Health-Gewicht (nach Import)",
      "Private Fotos (Pro) über PhotosPicker",
      "PDF-, CSV- & (fotofreier) JSON-Export",
    ],
    flags: { local: true, exports: true, reminders: true, healthkit: true },
    privacyIntro:
      "Der Entwickler erhebt keine Daten. Alle Einträge und Fotos bleiben auf dem Gerät, sofern du sie nicht ausdrücklich exportierst. HealthKit-Gewicht wird nur nach „Import“ gelesen und nie übertragen.",
    healthNote:
      "Apple Health ist optional und read-only: Nach „Import“ liest DoseLoom nur dein Körpergewicht aus Apple Health; es wird nie übertragen und DoseLoom schreibt nichts in Health.",
    cameraNote:
      "Private Fotos wählst du über den PhotosPicker; sie bleiben lokal und sind nie Teil von Exporten oder JSON-Sicherungen.",
    exportNote:
      "Lokale PDF-, CSV- und (fotofreie) JSON-Exporte verlassen das Gerät nur über Apples Teilen-Menü, ausgelöst durch dich. Private Fotos sind nie Teil der Exporte.",
    disclaimer:
      "DoseLoom ist ein persönliches Tracking-Tool, kein Medizinprodukt. Es diagnostiziert nicht, berechnet oder empfiehlt keine Dosen, ändert keine Behandlung, sagt keine Ergebnisse voraus und stellt keine Kausalität her. Nutzer müssen den Anweisungen ihres qualifizierten Gesundheitspersonals folgen.",
    supportNoteExtra: "Sende keine Medikamenten-, Symptom-, Gewichts- oder anderen sensiblen Gesundheitsdaten.",
    pricing: {
      proName: "DoseLoom Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Kern-Logging", "Manuelles Inventar", "Erinnerung", "Verlauf"],
      proIncludes: ["Private Fotos", "Tiefere neutrale Beobachtungen", "Vollständige Exporte (PDF, CSV, JSON)"],
    },
    faq: [
      { q: "Berechnet DoseLoom Dosen?", a: "Nein. DoseLoom ist ein persönliches Tracking-Tool, kein Medizinprodukt – es berechnet oder empfiehlt keine Dosen. Folge deinem Gesundheitspersonal." },
      { q: "Wie funktioniert der Health-Zugriff?", a: "Optional und read-only: nach „Import“ wird nur dein Gewicht gelesen und nie übertragen." },
      { q: "Sind meine Fotos in Exporten enthalten?", a: "Nein. Private Fotos bleiben lokal und sind nie Teil von PDF/CSV/JSON." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "menomosaic",
    name: "MenoMosaic",
    category: "Gesundheit & Fitness / Lifestyle",
    accent: "#B399EF",
    icon: "NotebookPen",
    iconImage: "/studio-assets/menomosaic/icon.webp",
    hero: "/studio-assets/menomosaic/hero.webp",
    tagline: "Dein privates Menopause-Journal – klarere Beobachtungen, nie medizinische Schlüsse.",
    description:
      "MenoMosaic ist ein privates Menopause-Journal für iPhone und iPad (iOS 17+): schneller Brain-Fog-Check-in, Hitzewallungs- und Zyklus-Logs, HRT/Behandlungs-Labels, Frage-Builder für Termine, neutrale 14-Tage-Vergleiche, Symptom-Ko-okkurrenz und PDF-/CSV-/JSON-Export.",
    features: [
      "Schneller Brain-Fog-Check-in",
      "Hitzewallungs- & Zyklus-Logs",
      "HRT-/Behandlungs-Labels",
      "Frage-Builder für Termine",
      "Neutrale 14-Tage-Vergleiche & Symptom-Ko-okkurrenz",
      "PDF-, CSV- & JSON-Export",
    ],
    flags: { local: true, exports: true, reminders: true, healthkit: true },
    privacyIntro:
      "Der Entwickler erhebt keine Daten. Alle Journaldaten bleiben auf dem Gerät, sofern du sie nicht ausdrücklich exportierst. Apple-Health-Schlaf wird nur nach „Import“ gelesen und nie übertragen.",
    healthNote:
      "Apple Health ist optional und read-only: Nach „Import“ liest MenoMosaic nur deine Schlafdaten aus Apple Health; sie werden nie übertragen und MenoMosaic schreibt nichts in Health.",
    exportNote:
      "Lokale PDF-, CSV- und JSON-Exporte verlassen das Gerät nur über Apples Teilen-Menü, ausgelöst durch dich.",
    disclaimer:
      "MenoMosaic dient nur der persönlichen Dokumentation und Termin-Vorbereitung. Es ist kein Medizinprodukt und diagnostiziert nicht, empfiehlt keine Behandlung, bewertet keine HRT-Wirksamkeit und stellt keine Kausalität her. Hol dir qualifizierten medizinischen Rat.",
    supportNoteExtra: "Sende keine Symptom-, Zyklus-, Behandlungs-, Schlaf- oder anderen sensiblen Gesundheitsdaten.",
    pricing: {
      proName: "MenoMosaic Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Check-ins, Hitzewallungen & Zyklus-Events", "Behandlungs-Labels & Fragen", "Erinnerung & Journal", "Keine Werbung"],
      proIncludes: ["Tiefere neutrale Vergleiche", "Symptom-Ko-okkurrenz", "Vollständige Exporte (PDF, CSV, JSON)"],
    },
    faq: [
      { q: "Bewertet MenoMosaic meine HRT?", a: "Nein. Es ist kein Medizinprodukt und bewertet keine Wirksamkeit. Hol dir qualifizierten medizinischen Rat." },
      { q: "Wie funktioniert der Health-Zugriff?", a: "Optional und read-only: nach „Import“ werden nur Schlafdaten gelesen und nie übertragen." },
      { q: "Wo liegen meine Journaldaten?", a: "Ausschließlich lokal auf dem Gerät, sofern du nicht ausdrücklich exportierst." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "flossmatch",
    name: "FlossMatch",
    category: "Werkzeug / Lifestyle",
    accent: "#F25FA1",
    icon: "Palette",
    iconImage: "/studio-assets/flossmatch/icon.webp",
    hero: "/studio-assets/flossmatch/hero.webp",
    tagline: "Kenne jeden Strang. Passe Farben an. Kauf nur einmal.",
    description:
      "FlossMatch (Thread Inventory) verwaltet ein durchsuchbares Faden-Inventar und eine Wunschliste, Projektbedarf mit reserviertem vs. verbrauchtem Bestand, eine konsolidierte Einkaufsliste, CIEDE2000-Farbabgleich, einen lokalen Foto-Farbsampler und PDF-/CSV-/JSON-Export. Sechs Sprachen, iPhone & iPad.",
    features: [
      "Durchsuchbares Faden-Inventar & Wunschliste",
      "Projektbedarf: reserviert vs. verbraucht",
      "Konsolidierte Einkaufsliste",
      "CIEDE2000-Farbabgleich",
      "Lokaler Foto-Farbsampler",
      "PDF-, CSV- & JSON-Export · sechs Sprachen",
    ],
    flags: { local: true, exports: true },
    privacyIntro:
      "FlossMatch erhebt keine Daten (Data Not Collected). Inventar, Projekte, ausgewählte Foto-Pixel und Abgleiche bleiben auf dem Gerät. Kein Konto, kein Backend, keine Werbung, keine Analyse, kein Tracking, kein Drittanbieter-SDK.",
    cameraNote:
      "Der Fotopicker übergibt der App nur das von dir gewählte Bild; FlossMatch lädt es nicht hoch und speichert es nicht. Der Foto-Farbsampler analysiert nur lokal.",
    disclaimer:
      "Bildschirmfarben und Referenzwerte sind Näherungen; physischer Faden, Beleuchtung und Färbepartien variieren. Markennamen dienen nur der Interoperabilität; FlossMatch ist unabhängig und nicht von Herstellern unterstützt.",
    pricing: {
      proName: "FlossMatch Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["50 Farben", "Drei Projekte", "Manueller Abgleich", "JSON-Portabilität"],
      proIncludes: ["Unbegrenzte Farben & Projekte", "Lokaler Foto-Farbsampler", "PDF- & CSV-Export"],
    },
    faq: [
      { q: "Lädt FlossMatch meine Fotos hoch?", a: "Nein. Der Fotopicker übergibt nur das gewählte Bild; es wird lokal analysiert, nicht hochgeladen oder gespeichert." },
      { q: "Sind die Farbabgleiche exakt?", a: "Es sind Näherungen (CIEDE2000). Physischer Faden, Licht und Färbepartien variieren." },
      { q: "Was ist gratis?", a: "50 Farben, drei Projekte, manueller Abgleich und JSON-Portabilität." },
      { q: "Ich habe Pro gekauft, aber es ist nicht aktiv.", a: "Tippe auf „Käufe wiederherstellen“ und melde dich mit derselben Apple-ID an." },
    ],
  },
  {
    slug: "islandink",
    name: "IslandInk",
    category: "Spiele / Puzzle",
    accent: "#2FA7F7",
    icon: "Puzzle",
    iconImage: "/studio-assets/islandink/icon.webp",
    hero: "/studio-assets/islandink/hero.webp",
    tagline: "Forme Inseln. Verbinde die Wand. Löse täglich ein ruhiges Gitter.",
    description:
      "IslandInk ist ein eigenständiges, deterministisches Nurikabe-Logikspiel: Jede nummerierte Insel enthält genau so viele Zellen, die dunkle Wand ist eine zusammenhängende Fläche und ein 2×2-Wandblock ist verboten. Mit Daily Island, Weekly Reef, 5×5/6×6/7×7-Levelpfad, erklärten Hinweisen, Streak-Kalender, Offline-Archiv und optionalem Game Center.",
    features: [
      "Daily Island",
      "Weekly Reef",
      "5×5/6×6/7×7-Levelpfad",
      "Erklärte Hinweise",
      "Streak-Kalender & Offline-Archiv",
      "Optionales Apple Game Center",
    ],
    flags: { local: true, gamecenter: true, exports: true },
    privacyIntro:
      "IslandInk erhebt keine Daten (Data Not Collected). Fortschritt bleibt lokal auf dem Gerät; Teilen nur nach ausdrücklicher Aktion. Apple verarbeitet StoreKit und optionales Game Center; ViralCrew betreibt keinen Server und erhält kein Spielerprofil.",
    gamecenterNote:
      "IslandInk nutzt optional Apple Game Center. Apple verarbeitet StoreKit- und Game-Center-Daten unter deinem Apple-Konto; ViralCrew betreibt keinen Server und erhält kein Spielerprofil.",
    exportNote:
      "Daten verlassen das Gerät nur, wenn du ein Ergebnis teilst oder eine JSON-Sicherung exportierst – jeweils über das Apple-Teilen-Menü und nur durch dich ausgelöst.",
    disclaimer:
      "IslandInk ist ein Unterhaltungsspiel und kein Leistungsversprechen. Jedes erzeugte Board wird unabhängig auf genau eine gültige Lösung und einen vollständigen logischen Hinweispfad geprüft. Game-Center-Ranglisten sind optional; Verfügbarkeit und Kontoverarbeitung liegen bei Apple.",
    pricing: {
      proName: "IslandInk Pro", noAmounts: true, trialDays: 7,
      freeIncludes: ["Daily", "Levelpfad 1–12", "Sieben Archivtage"],
      proIncludes: ["Unbegrenzter Levelpfad", "Weekly Reef", "365 Archivtage"],
    },
    faq: [
      { q: "Wie sind die Regeln?", a: "Jede nummerierte Insel enthält genau so viele Zellen, die dunkle Wand ist zusammenhängend und ein 2×2-Wandblock ist verboten." },
      { q: "Sind die Rätsel eindeutig lösbar?", a: "Ja. Jedes Board wird unabhängig auf genau eine gültige Lösung und einen vollständigen logischen Hinweispfad geprüft." },
      { q: "Wie funktioniert Game Center?", a: "Optional. Apple verarbeitet die Daten unter deinem Konto; ViralCrew erhält kein Spielerprofil." },
      { q: "Was ist in Free und Pro enthalten?", a: "Free: Daily, Level 1–12 und sieben Archivtage. Pro: unbegrenzter Pfad, Weekly Reef und 365 Archivtage." },
    ],
  },
];

export const getApp = (slug) => APPS.find((a) => a.slug === slug);
